exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-item{\n    width: 100%;\n    margin-bottom: 2px;\n    background-color: #EEE;\n    color: #555;\n    border: none;\n    text-align: left !important;\n}\n.btn-item:hover,\n.btn-item:focus{\n    background-color: #DDD;\n    color: #555;\n}\n.button-cerrar{\n    background-color: rgb(236, 65, 65);\n    position: absolute;\n    right: -10px;\n    top: -9px;\n    padding: 1px 6px;\n    border-radius: 50%;\n}\n.table-cuentas,\n.table-cuentas td{\n    border: 0px;\n    padding: 0px;\n    margin: 0px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/facturar-pedido-modal/facturar-pedido-modal.component.css
// module id = ../../../../../src/app/components/modals/facturar-pedido-modal/facturar-pedido-modal.component.css
// module chunks = main